import Vue from "vue";

Vue.filter('currency', function (price) {
  if (price == null) {
    price = 0
  }
  return parseFloat(price).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    style: "currency",
    currency: "BRL",
  });
});

Vue.filter('date', function (date) {
  return new Date(date).toLocaleString();
});

Vue.filter('weight', function (value) {
  return parseFloat(value).toFixed(3);
});

Vue.filter('double', function (value) {
  return parseFloat(value).toFixed(2);
});



Vue.filter('normalize', function (value, search, item) {
  const text = value
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  return (
    text.indexOf(
      search
        .trim()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
    ) !== -1
  );
});